var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscgolfanlaeg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.59 15.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n      fill: #071f39;\n      }\n\n      .cls-1, .cls-2 {\n      stroke-width: 0px;\n      }\n\n      .cls-2 {\n      fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cirkel"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 0,
    width: 15.59,
    height: 15.59,
    rx: 7.8,
    ry: 7.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ICONS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.86,10.01c-.12-.04-.24.02-.28.13-.04.12.02.24.13.28.92.33,1.48.81,1.48,1.26,0,.84-1.81,1.73-4.5,1.73s-4.5-.9-4.5-1.73c0-.12-.1-.22-.22-.22s-.22.1-.22.22c0,1.22,2.17,2.18,4.95,2.18s4.95-.96,4.95-2.18c0-.67-.63-1.27-1.77-1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.32,4.96c.75-.32,1.26-.81,1.14-1.09s-.83-.26-1.58.06c-.75.32-1.26.81-1.14,1.09.12.29.83.26,1.58-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.22,8.69h1.44v2.59c-.36.05-.64.22-.66.45.02.23.42.42.88.42s.85-.19.88-.47c-.02-.2-.3-.35-.66-.4v-2.59h1.42c.51,0,.92-.41.92-.92v-.46c0-.12-.1-.22-.22-.22h-2.12v-.33h.44c.67,0,1.22-.55,1.22-1.22V1.97h-3.77v3.56c0,.67.55,1.22,1.22,1.22h.44v.33h-2.14c-.12,0-.22.1-.22.22v.46c0,.51.41.92.92.92ZM10.1,6.31v-3.11h.36v2.86c0,.14-.11.25-.25.25h-.11ZM11.32,5.53c0,.31-.18.57-.44.69.02-.06.04-.11.04-.17v-2.86h.41v2.34ZM8.44,5.53v-2.34h.41v2.84c0,.07.02.13.04.19-.26-.12-.45-.39-.45-.7ZM9.56,6.31c-.15,0-.27-.12-.27-.27v-2.84h.36v3.11h-.09ZM12,7.77c0,.26-.21.47-.47.47h-.44c.08-.14.15-.29.15-.46v-.25h.77v.24ZM10.79,7.53v.25c0,.26-.21.46-.46.46h-.22v-.71h.69ZM9.66,7.53v.71h-.24c-.25,0-.46-.21-.46-.46v-.26h.7ZM7.74,7.53h.77v.26c0,.17.06.32.14.46h-.44c-.26,0-.47-.21-.47-.47v-.24Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscgolfanlaeg);
export default __webpack_public_path__ + "static/media/DISCGOLFANLAEG.e7e40cfb4a0d75502883d83fff08a8fe.svg";
export { ForwardRef as ReactComponent };